module.exports = __webpack_public_path__ + "static/6305-woodrose-54-ddfbb3019392f0d452eca5d54a6b830a.jpg";